import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { RegisterItemStatus } from '@core/entities/register/RegisterItem/types'
import { IRegisterItemTargetResult } from './IRegisterItemTargetResult'

export class RegisterItemTargetResult extends Entity<IRegisterItemTargetResult> {
  id: number
  organisationId: number
  uniqueId: string
  description?: string
  registerName?: string
  registerId?: number
  projectId?: number
  status?: RegisterItemStatus

  public static new(
    payload: IRegisterItemTargetResult,
  ): RegisterItemTargetResult {
    return plainToInstance(RegisterItemTargetResult, payload)
  }

  // Falls back to the unique id when the register item has no description property
  public getDescriptionText(): string {
    return this.description?.trim() || this.uniqueId
  }
}
